module.exports = __webpack_public_path__ + "static/media/R-150XLHD_CrossSection.edd7e612.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/R-150XLHD_CrossSection.png
// module id = 476
// module chunks = 0